import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { UpdateAnnouncementDisplayService } from '../../../services/shared/update-announcements/update-announcement-display.service';
import { IUpdateAnnouncementFeed } from '../../../services/shared/update-announcements/update-announcement.interface';
import { UpdateAnnouncementFeedService } from '../../../services/shared/update-announcements/update-announcement-feed.service';


@Component({
	selector: 'app-update-badge',
	templateUrl: './update-badge.component.html',
	styleUrls: ['./update-badge.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
	host: { '[class.is-visible]': 'isVisible' }
})
export class UpdateBadgeComponent implements OnInit, OnDestroy {

	//** UI Variables */
	updateName	: string = '';
	isVisible	: boolean = false;

	//** Subscriptions */
	private readonly subscriptions: Subscription = new Subscription();


	constructor(
		@Inject(UpdateAnnouncementFeedService) private readonly updateAnnouncementFeedService: UpdateAnnouncementFeedService,
		@Inject(UpdateAnnouncementDisplayService) private readonly updateAnnouncementDisplayService	: UpdateAnnouncementDisplayService,
		private readonly changeDetectorRef		: ChangeDetectorRef
	) {}


	/**------------------------------------------------------
	 * Lifecycle Hooks
	 */
	ngOnInit(): void {
		this.subscriptions.add(this.updateAnnouncementFeedService.feed$.subscribe((feed: IUpdateAnnouncementFeed) => {
			this.updateName = feed.updates[0]?.badgeLabel || '';
			this.isVisible = feed.enabled && feed.badgeEnabled && feed.updates.length > 0;
			this.changeDetectorRef.markForCheck();
		}));
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}


	/**------------------------------------------------------
	 * UI Helpers
	 */
	openUpdates(): void {
		if (!this.isVisible) return;
		this.updateAnnouncementDisplayService.open();
	}
}
